import { Select } from "antd";
const { Option } = Select;

/** 数据集生成列表Option */
const getList = () => {
};

/**
 * 获取通用列表
 * @param rows 数据集
 * @param options 选项
 * @returns Option 
 */
getList.general = (rows: any, options?: {
    /** Option.item.id，默认：'id' */
    itemId?: string;
    /** Option.item.name，默认：'name' */
    itemName?: string;
    /** Option.item.name是否包含id */
    isItemNameIncludeId?: boolean;
    /** callbakc，设置Name函数，如存在，itemName参数无效，
     * 例如：setItemNameFun: (item: any): { id?: string, name: string } => {
     * const { id, name} = item;
     * return { id, name};
     * }
     */
    setItemNameFun?: (item: any) => { id: string, name: string };
    /** 没有id键的数组 */
    noId?: boolean;
    /** 包括：无(NULL)，默认：false */
    includeNull?: boolean;
}) => {
    let { itemId = 'id', itemName = 'name', isItemNameIncludeId,
        setItemNameFun, noId, includeNull } = options || {};
    /** 返回 */
    let res: any;
    if (typeof rows !== "undefined") {
        if (Array.isArray(rows) === false) {
            rows = [rows];
        }
        if (includeNull === true) {
            rows = rows.concat({
                [itemId]: null,
                [itemName]: '无（null）'
            });
        }
        res = rows.map((item: any, key: number) => {
            /** 当前id */
            let currentId = (noId === true ? item : item[itemId as string]);
            /** 当前name */
            let currentName;
            if (setItemNameFun) {
                const obj = setItemNameFun(item);
                if (typeof obj !== 'undefined') {
                    const { id, name } = obj;
                    currentId = (typeof id !== 'undefined' ? id : currentId);
                    currentName = name;
                }
            } else {
                currentName = noId === true ? item : item[itemName as string];
            }
            if (currentId === null) {
                currentName = '无（null）';
            }
            // 注意：null 项不再拼接 id，避免出现 "null - [无（null）]"
            if (isItemNameIncludeId === true && currentId !== null) {
                currentName = `${currentId} - [${currentName}]`;
            }
            // Ant Design 的 Option 不允许 value 为 null，这里转成 undefined；
            // item 仍然保留原始对象（内部 null 值不变），便于 onChange 里通过 opt.item 取原值。
            return (
                <Option
                    value={currentId === null ? undefined : currentId}
                    item={item}
                    key={key}
                >
                    {currentName}
                </Option>
            );
        })
    }
    return res;
};

/**
 * 获取通用列表（新版，返回普通对象数组，配合 <Select options={...} /> 使用）
 * 说明：
 *  - 与 getList.general 参数完全一致，返回结果可直接用于 Select 的 options 属性；
 *  - 不再返回 <Option> 元素，因此不会触发 Ant Design 的 “Option 已弃用” 提示；
 *  - 每一项里保留 item 字段，便于 onChange 的第二个参数 opt.item 取原始数据；
 *  - value 为 null 时统一转为 undefined，避免 Select 的空值警告。
 * @param rows 数据集
 * @param options 选项
 * @returns 选项对象数组
 */
getList.general2 = (rows: any, options?: {
    /** Option.item.id，默认：'id' */
    itemId?: string;
    /** Option.item.name，默认：'name' */
    itemName?: string;
    /** Option.item.name是否包含id */
    isItemNameIncludeId?: boolean;
    /** callbakc，设置Name函数，如存在，itemName参数无效，
     * 例如：setItemNameFun: (item: any): { id?: string, name: string } => {
     * const { id, name} = item;
     * return { id, name};
     * }
     */
    setItemNameFun?: (item: any) => { id: string, name: string };
    /** 没有id键的数组 */
    noId?: boolean;
    /** 包括：无(NULL)，默认：false */
    includeNull?: boolean;
}) => {
    let { itemId = 'id', itemName = 'name', isItemNameIncludeId,
        setItemNameFun, noId, includeNull } = options || {};
    /** 返回 */
    let res: any;
    if (typeof rows !== "undefined") {
        if (Array.isArray(rows) === false) {
            rows = [rows];
        }
        if (includeNull === true) {
            rows = rows.concat({
                [itemId]: null,
                [itemName]: '无（null）'
            });
        }
        res = rows.map((item: any, key: number) => {
            /** 当前id */
            let currentId = (noId === true ? item : item[itemId as string]);
            /** 当前name */
            let currentName;
            if (setItemNameFun) {
                const obj = setItemNameFun(item);
                if (typeof obj !== 'undefined') {
                    const { id, name } = obj;
                    currentId = (typeof id !== 'undefined' ? id : currentId);
                    currentName = name;
                }
            } else {
                currentName = noId === true ? item : item[itemName as string];
            }
            if (currentId === null) {
                currentName = '无（null）';
            }
            // 注意：null 项不再拼接 id，避免出现 "null - [无（null）]"
            if (isItemNameIncludeId === true && currentId !== null) {
                currentName = `${currentId} - [${currentName}]`;
            }
            // 返回普通对象，供 Select 的 options 使用；
            // value 为 null 时转成 undefined，item 保留原始对象。
            return {
                label: currentName,
                value: currentId === null ? undefined : currentId,
                item,
                key,
            };
        })
    }
    return res;
};

export default getList;